 import Table from './Table'
//import formItem from './formItem'
// import item from './item'
// import upload from './upload'
// import level from './level'
 import job from './job'
// import city from './city'
// import code from './code'


function plugins(Vue) {
  Vue.component('v-Table', Table)
  //Vue.component('form-Item', formItem)
  // Vue.component('v-item', item)
  // Vue.component('v-upload', upload)
  // Vue.component('v-level', level)
   Vue.component('v-job', job)
  // Vue.component('v-city', city)
  // Vue.component('v-code', code)

}
export default plugins
